import React from 'react';
import throttle from 'lodash.throttle';

import { on, off } from './lib/event';

class ScrollBox extends React.Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleScroll = throttle(this.handleScroll, 200);
    this.callHandler = throttle(this.callHandler, 1000);
  }
  componentDidMount() {
    on(window, 'scroll', this.handleScroll);
  }
  componentWillUnmount() {
    off(window, 'scroll', this.handleScroll);
  }
  handleScroll() {
    const windowTop = window.pageYOffset;
    const windowBottom = windowTop + window.innerHeight;
    const rect = this.node.getBoundingClientRect();
    const nodeTop = rect.top + windowTop;
    const nodeBottom = nodeTop + this.node.offsetHeight;

    if (nodeBottom - windowBottom < this.props.threshold) {
      this.callHandler();
    }
  }
  callHandler() {
    this.props.onScrollNear();
  }
  render() {
    return (
      <div ref={((node) => this.node = node)}>
        {this.props.children}
      </div>
    );
  }
};

ScrollBox.defaultProps = {
  threshold: 400,
};

export default ScrollBox;



// WEBPACK FOOTER //
// ./src/ScrollBox.js